import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';

import enAction from '@/i18n/locales/en/action.json';
import thAction from '@/i18n/locales/th/action.json';
import enDescription from '@/i18n/locales/en/description.json';
import thDescription from '@/i18n/locales/th/description.json';
import enDevelopment_tenant from '@/i18n/locales/en/development_tenant.json';
import thDevelopment_tenant from '@/i18n/locales/th/development_tenant.json';
import enError from '@/i18n/locales/en/error.json';
import thError from '@/i18n/locales/th/error.json';
import enInput from '@/i18n/locales/en/input.json';
import thInput from '@/i18n/locales/th/input.json';
import enList from '@/i18n/locales/en/list.json';
import thList from '@/i18n/locales/th/list.json';
import enMfa from '@/i18n/locales/en/mfa.json';
import thMfa from '@/i18n/locales/th/mfa.json';
import enOther from '@/i18n/locales/en/other.json';
import thOther from '@/i18n/locales/th/other.json';
import enProfile from '@/i18n/locales/en/profile.json';
import thProfile from '@/i18n/locales/th/profile.json';
import enSecondary from '@/i18n/locales/en/secondary.json';
import thSecondary from '@/i18n/locales/th/secondary.json';
import enUser_scopes from '@/i18n/locales/en/user_scopes.json';
import thUser_scopes from '@/i18n/locales/th/user_scopes.json';
import enWelcome from '@/i18n/locales/en/welcome.json';
import thWelcome from '@/i18n/locales/th/welcome.json';

export const SUPPORTED_LOCALES = ['th', 'en'] as const;
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number];
export const DEFAULT_LOCALE: SupportedLocale = 'th';

export function createI18nInstance() {
  const i18n = i18next.createInstance();

  i18n.use(initReactI18next).init({
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: SUPPORTED_LOCALES,

    interpolation: {
      escapeValue: false,
    },

    resources: {
      en: {
        translation: {
          action: enAction,
          description: enDescription,
          development_tenant: enDevelopment_tenant,
          error: enError,
          input: enInput,
          list: enList,
          mfa: enMfa,
          other: enOther,
          profile: enProfile,
          secondary: enSecondary,
          user_scopes: enUser_scopes,
          welcome: enWelcome,
        }
      },
      th: {
        translation: {
          action: thAction,
          description: thDescription,
          development_tenant: thDevelopment_tenant,
          error: thError,
          input: thInput,
          list: thList,
          mfa: thMfa,
          other: thOther,
          profile: thProfile,
          secondary: thSecondary,
          user_scopes: thUser_scopes,
          welcome: thWelcome,
        }
      },
    },

    react: {
      useSuspense: false,
    },
  });

  return i18n;
}
